<template>
  <v-autocomplete
    v-model="inspectionValue"
    @input="handleInput"
    :clearable="clearable"
    :dense="dense"
    :disabled="disabled"
    :items="inspections"
    :item-value="itemValue"
    :loading="isLoading"
    :multiple="multiple"
    :outlined="outlined"
    :readonly="readonly"
    :return-object="returnObject"
    :rules="rules"
    :search-input="search"
    item-text="name"
    :label="$tc('categories.inspection.name', 1)"
  ></v-autocomplete>
</template>

<script>
import InspectionService from "@/services/InspectionService"
export default {
  props: {
    rules: {
      type: Array,
      default: () => []
    },
    outlined: {
      type: Boolean,
      default: false
    },
    returnObject: {
      type: Boolean,
      default: true
    },
    itemValue: {
      type: String,
      default: "pk"
    },
    dense: {
      type: Boolean,
      default: false
    },
    multiple: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    value: {
      default: null
    }
  },
  data() {
    return {
      inspection_id: null,
      search: "",
      isLoading: false,
      inspectionValue: null,
      inspections: []
    }
  },
  created() {
    if (this.value) {
      this.inspectionValue = this.value
    } else if (this.$route.query.inspection) {
      this.inspection_id = this.$route.query.inspection
    } else if (this.$route.params.id) {
      this.inspection_id = this.$route.params.id
    }
    this.getInspections()
  },
  watch: {
    value: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue) this.inspectionValue = newValue
      }
    }
  },
  methods: {
    getInspections() {
      this.isLoading = true
      InspectionService.getAll(this.$store.state.app.project.id)
        .then(r => {
          if (this.inspection_id) {
            const found = r.results.find(o => o.id == this.inspection_id)
            if (found) {
              this.inspectionValue = this.returnObject ? found : found.id
              this.handleInput()
            }
          }
          this.inspections = r.results
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    handleInput() {
      const $ = this
      this.$nextTick(() => {
        $.$emit("input", this.inspectionValue)
      })
    }
  }
}
</script>
